export enum HtmlSanitiserEvent {
    BeforeElement = "beforeSanitizeElements",
    OnAttribute = "uponSanitizeAttribute",
    AfterAttribute = "afterSanitizeAttributes"
}
